import dayjs from "dayjs";
import "dayjs/locale/es";

import { Typography } from "antd";
import { ArrowUpOutlined } from "@ant-design/icons";

import { ImagenOptimizada as Img } from "../../../../Components/Image/web";
import { FincaraizBlogCategory } from "../FincaraizNewsSection.config";
import { buildBlogPostLink } from "../FincaraizNewsSection.links";
import { FincaraizNewsPost } from "../FincaraizNewsSection.hook";

const { Title, Link, Paragraph } = Typography;

const formatNewsDate = (created: string) => {
	return dayjs(created).locale("es").format("D MMM YYYY");
};

interface NewsCardFincaraizProps {
	news: FincaraizNewsPost;
	category: FincaraizBlogCategory;
	blogBaseUrl?: string;
}

export const NewsCardFincaraiz = ({ news, category, blogBaseUrl }: NewsCardFincaraizProps) => {
	const link = buildBlogPostLink(blogBaseUrl, news.slug, news.url);

	return (
		<article className="news-card-fincaraiz">
			<Link
				className="news-card-fincaraiz__image-link"
				href={link}
				target="_blank"
				rel="noopener noreferrer"
				title={news.title}>
				<div className="news-card-fincaraiz__image-wrap">
					<Img src={news.image} alt={news.title} />
					<span className="news-card-fincaraiz__tag">
						<span
							className="news-card-fincaraiz__tag-dot"
							style={{ backgroundColor: category.color }}
						/>
						{category.label}
					</span>
				</div>
			</Link>

			<div className="news-card-fincaraiz__body">
				<div className="news-card-fincaraiz__meta">
					<span>{formatNewsDate(news.created)}</span>
				</div>

				<Title className="news-card-fincaraiz__title" level={4} ellipsis={{ rows: 2 }}>
					{news.title}
				</Title>

				{news.description && (
					<Paragraph className="news-card-fincaraiz__description" ellipsis={{ rows: 2 }}>
						{news.description}
					</Paragraph>
				)}

				<Link
					className="news-card-fincaraiz__cta"
					href={link}
					target="_blank"
					rel="noopener noreferrer"
					style={{ color: category.color }}>
					{category.cta}
					<ArrowUpOutlined className="news-card-fincaraiz__cta-icon" />
				</Link>
			</div>
		</article>
	);
};
